<template>
    <div class="data" v-if="visible"></div>
</template>

<script>
import router from "../router.js";
import EventBus from "../eventbus.js";

export default {
    props: ["drivers"],
    data: function() {
        return {
            localDrivers: [],
            visible: false
        };
    },
    created() {},
    mounted() {
        this.localDrivers = this.$store.getters.drivers;

        //if there aren't any drivers already in the store
        //get the default ones
        if (this.localDrivers.length === 0) {
            this.$store.dispatch("updateDrivers", this.drivers);
        }
    },
    methods: {},
    components: {}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DataSet.vue